
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { LoadingButton } from "@/components/ui/loading-button";
import { Label } from "@/components/ui/label";
import { useOnboardingState } from "@/integrations/supabase/onboarding";
import { Input } from "@/components/ui/input";

const Step4Recording = ({ onNext, onPrev }: { onNext: () => void; onPrev: () => void }) => {
  const { onboarding, saveRecordingPrefs } = useOnboardingState();
  const [recordingEnabled, setRecordingEnabled] = useState(
    onboarding?.recording_enabled != null ? onboarding.recording_enabled : true
  );
  const [retention, setRetention] = useState(
    onboarding?.retention_days != null ? String(onboarding.retention_days) : "30"
  );
  const [loading, setLoading] = useState(false);

  async function handleSave(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    await saveRecordingPrefs(recordingEnabled, +retention);
    setLoading(false);
    onNext();
  }
  return (
    <form className="space-y-4" onSubmit={handleSave}>
      <div>
        <div className="flex items-center space-x-2">
          <input 
            type="checkbox" 
            id="recording-enabled" 
            checked={recordingEnabled} 
            onChange={e => setRecordingEnabled(e.target.checked)} 
            className="h-4 w-4"
          />
          <Label htmlFor="recording-enabled">Recording Enabled</Label>
        </div>
      </div>
      <div>
        <Label htmlFor="retention-period" className="block mb-1">Retention Period (days)</Label>
        <Input
          id="retention-period"
          type="number"
          min={1}
          max={365}
          value={retention}
          onChange={e => setRetention(e.target.value)}
          className="w-24"
        />
      </div>
      <div className="flex space-x-2">
        <Button type="button" variant="secondary" onClick={onPrev}>Back</Button>
        <LoadingButton type="submit" loading={loading}>Continue</LoadingButton>
      </div>
    </form>
  );
};
export default Step4Recording;
